// src/services/sombra.js -- apoio do dual-run RTDB x API (plano §2.1, F2).
//
// O modo `sombra` roda as duas implementacoes e DECIDE pela RTDB; a API ali e'
// observacao. Este modulo concentra as duas consequencias disso: tolerar a
// falha do lado observado e registrar a divergencia.
//
// O plano previa `POST /dashboard/api/gate-sombra/` "so se existir": nao existe
// no backend da F1 (dashboard/urls.py:4-12 so tem vitalicio/ e atribuicao/),
// entao a divergencia fica no console, em JSON, sem telefone em claro.

// FNV-1a 32 bits. NAO e' hash criptografico -- serve so para correlacionar
// divergencias do mesmo telefone sem escrever o numero no console do aparelho
// do usuario (o log do navegador e' visivel para quem estiver junto).
const OFFSET_FNV = 0x811c9dc5;
const PRIMO_FNV = 0x01000193;

export function hashCurto(texto) {
  const conteudo = String(texto);
  let acumulado = OFFSET_FNV;
  for (let i = 0; i < conteudo.length; i += 1) {
    acumulado = Math.imul(acumulado ^ conteudo.charCodeAt(i), PRIMO_FNV);
  }
  return (acumulado >>> 0).toString(16).padStart(8, '0');
}

/**
 * Emite uma linha JSON estruturada com a divergencia entre RTDB e API.
 *
 * Exemplo:
 *   registrarDivergencia('gate_sombra_divergencia',
 *     { telefone_hash: hashCurto('11957218700'), rtdb, api });
 */
export function registrarDivergencia(evento, campos, saida = console) {
  saida.warn(JSON.stringify({ evento, ...campos }));
}

/**
 * Roda a chamada observada sem deixar o erro dela vazar: em sombra, a API nao
 * pode derrubar quem ja passaria pela RTDB. O `{erro}` devolvido nunca casa com
 * a decisao da RTDB, entao a falha aparece como divergencia no log.
 */
export async function tolerarFalhaDaApi(chamada) {
  try {
    return await chamada();
  } catch (erro) {
    return { erro: erro.message };
  }
}
